export default ({ app }, inject) => {
    inject('validateText', (prismicElement) => {
        if (typeof(prismicElement) === 'string') {
            return Boolean(prismicElement?.trim());
        }
        return Boolean(app.$prismic.asText(prismicElement)?.trim());
    });
    return app;
};